import { Listing, OfferType } from '@smg-real-estate/hg-rets-schema';

import { isLocationValidForUbs } from '../functions/helpers';

export const isListingValidForUbsGuide = (listing: Listing): boolean => {
  return (
    !!listing.address?.postalCode &&
    listing.offerType !== OfferType.Rent &&
    isLocationValidForUbs(listing)
  );
};

export const getCommuneIdByPostalCode = (
  mapPostalCodes: any[],
  postalCode: string,
): number | null => {
  const mapItem = mapPostalCodes.find((item: any[]) => item[0].toString() === postalCode);
  return mapItem ? mapItem[1] : null;
};

export const getActionLink = ({
  url,
  locale,
  offerType,
  postalCode,
  communeId,
}: {
  url: string;
  locale: string;
  offerType: OfferType;
  postalCode: string;
  communeId?: number | null;
}): string => {
  const queryStrings: string[] = [`lang=${locale}`, `offerType=${offerType}`, `ao=${postalCode}`];
  if (communeId) {
    queryStrings.push(`commune=${communeId}`);
  }
  return `${url}?${queryStrings.join('&')}`;
};
